import {IElement, IImageAttributes, IColorOverlay} from 'routes/private/Editor/types';

export const colorOverlayResolver = ( element: IElement, colorOverlay: IColorOverlay) => {    
    (element.attributes as IImageAttributes).colorOverlay = colorOverlay
    return element;
}


